import { getImage } from '../../../../utils/imageHelper';
import { Button } from 'primereact/button';
import { useImageCompressingContext } from '../../../../contexts/ImageCompressingContext';
import ImageCompressing from './ImageCompressing';

function ImageItem({
  image,
  alt,
  imageClassName,
  deleteImage,
  previewMode = false,
  mainImageMode = false,
  imageLoad
}) {
  const { imageCompressingContext } = useImageCompressingContext();

  return (
    <div key={image.id} className="flex flex-col gap-y-1 relative">
      {!previewMode && imageCompressingContext?.image.id === image.id && <ImageCompressing />}
      <img
        src={image.file || getImage('img-ph.png')}
        className={`${imageClassName} object-cover`}
        alt={alt}
        onLoad={imageLoad ? imageLoad : undefined}
      />

      {!previewMode && !mainImageMode && (
        <Button
          icon="pi pi-trash"
          rounded
          raised
          text
          className={`absolute top-3 right-3 text-xs bg-white`}
          severity="danger"
          aria-label="Supprimer l'image"
          onClick={deleteImage}
        />
      )}
      {image.label && <span className="text-slate-600 text-sm pl-1 h-6">{image.label}</span>}
    </div>
  );
}

export default ImageItem;
